import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	description: {
		marginTop: theme.spacing(5),
		marginBottom: theme.spacing(2),
		padding: `0px ${theme.spacing(12)}px`,
		lineHeight: '1.5'
	},
	support: {
		marginTop: theme.spacing(5),
		marginBottom: theme.spacing(3.5)
	}
}));
